import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * The Happy Logistics "deliveries that need a person" count, for the sidebar.
 *
 * Asana 1220178212808423 removed the page's own sub-menu, which is where this
 * count was shown (on its Deliveries entry). The sidebar's Deliveries entry
 * now carries it instead. The page already has the number — it comes on the
 * connection it loads — so it publishes it here rather than the sidebar
 * fetching anything: no new request, and 0 whenever the page is not open,
 * which is exactly when the old in-page badge was not visible either.
 */
@Injectable({ providedIn: 'root' })
export class HappyLogisticsAttentionService {
  private readonly countSubject = new BehaviorSubject<number>(0);
  readonly count$ = this.countSubject.asObservable();

  set(n: number): void {
    const v = Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
    if (v !== this.countSubject.value) this.countSubject.next(v);
  }
}
